import React, { Component } from 'react'
import './Contact.css'

class Contact extends Component {
  
    render () {
        return (
            <div className="bodyContact">
                <div className="contact">
                    <h1>guillaume.queste@laposte.net</h1>
                </div>
            </div>
        )
    }
}

export default Contact